import { c as _c } from "react/compiler-runtime";
import { WidgetWithStore } from "../../../shared/components/Widget/components/WidgetWithStore";
import { RecurringDonation } from "../../../shared/components/Widget/types/Enums";
import { WidgetProps } from "../../../shared/components/Widget/types/WidgetProps";
import { PrefilledDistribution } from "../../layout/WidgetPane/WidgetPane";
import { Paragraph } from "../Paragraph/Paragraph";
import styles from "./DonationWidgetBlock.module.scss";
import { EffektButton } from "../../../shared/components/EffektButton/EffektButton";
import { getExternalDonationUrls } from "../../../../util/externalDonationWidget";
export const DonationWidgetBlock: React.FC<{
  widgetConfiguration: WidgetProps;
  overrides?: any;
  content?: any[];
}> = t0 => {
  const $ = _c(26);
  const {
    widgetConfiguration,
    overrides,
    content
  } = t0;
  let defaultPaymentType = RecurringDonation.NON_RECURRING;
  if (overrides?.default_donation_type) {
    if (overrides.default_donation_type === "recurring") {
      defaultPaymentType = RecurringDonation.RECURRING;
    }
    if (overrides.default_donation_type === "single") {
      defaultPaymentType = RecurringDonation.NON_RECURRING;
    }
  }
  let t1;
  if ($[0] !== widgetConfiguration.external_donation_widget) {
    t1 = getExternalDonationUrls(widgetConfiguration.external_donation_widget);
    $[0] = widgetConfiguration.external_donation_widget;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const externalDonationUrls = t1;
  if (externalDonationUrls) {
    const href = overrides?.default_donation_type === "recurring" ? externalDonationUrls.recurring : overrides?.default_donation_type === "single" ? externalDonationUrls.single : externalDonationUrls.default;
    let t2;
    if ($[2] !== href) {
      t2 = () => window.location.href = href;
      $[2] = href;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t2 || $[5] !== widgetConfiguration.donate_label) {
      t3 = <EffektButton onClick={t2}>{widgetConfiguration.donate_label}</EffektButton>;
      $[4] = t2;
      $[5] = widgetConfiguration.donate_label;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== content) {
      t4 = content && content.length > 0 && <Paragraph title="" tocKey="" blocks={content} />;
      $[7] = content;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== t3 || $[10] !== t4) {
      t5 = <div className={styles.wrapper}>{t3}{t4}</div>;
      $[9] = t3;
      $[10] = t4;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  let t2;
  if ($[12] !== widgetConfiguration) {
    t2 = {
      data: {
        result: widgetConfiguration,
        query: ""
      }
    };
    $[12] = widgetConfiguration;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  const t3 = overrides?.prefilled_distribution;
  let t4;
  if ($[14] !== t3) {
    t4 = convertToPrefilledDistribution(t3);
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const t5 = overrides?.prefilled_sum ?? null;
  let t6;
  if ($[16] !== defaultPaymentType || $[17] !== t2 || $[18] !== t4 || $[19] !== t5) {
    t6 = <div className={styles.widget}><WidgetWithStore inline={true} {...t2} prefilled={t4} prefilledSum={t5} defaultPaymentType={defaultPaymentType} /></div>;
    $[16] = defaultPaymentType;
    $[17] = t2;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== content) {
    t7 = content && content.length > 0 && <Paragraph title="" tocKey="" blocks={content} />;
    $[21] = content;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t6 || $[24] !== t7) {
    t8 = <div className={styles.wrapper}>{t6}{t7}</div>;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
};

// Input type
type InputDistribution = {
  _key: string;
  id: number;
  causeAreaId?: number;
  name: string;
  percentage: number;
  type: "causeArea" | "organization";
}[];

/**
 * Converts from the input format to PrefilledDistribution
 * @param input The input distribution array
 * @returns The converted PrefilledDistribution
 */
function convertToPrefilledDistribution(input?: InputDistribution): PrefilledDistribution | null {
  if (!input) return null;
  if (input.length === 0) return null;
  const result: PrefilledDistribution = [];

  // Separate cause areas and organizations
  const causeAreas = input.filter(item => item.type === "causeArea");
  const organizations = input.filter(item => item.type === "organization");

  // Create each cause area entry in the result
  causeAreas.forEach(causeArea => {
    const causeAreaId = causeArea.id;
    const relatedOrgs = organizations.filter(org => org.causeAreaId === causeAreaId);
    result.push({
      causeAreaId: causeAreaId,
      share: causeArea.percentage,
      organizations: relatedOrgs.map(org => ({
        organizationId: org.id,
        share: org.percentage
      }))
    });
  });
  return result;
}